/**
 * @generated SignedSource<<270a8763bde6e8a6b1f015f9a7a2f8e7>>
 * @relayHash 8a0218b2e1c99a56ce8c33454f5c992d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0cf895ac8ba230224c74d275c984b0c91d2ac44dddcf2fde63e3993339c6b240

import type { ConcreteRequest } from 'relay-runtime';
export type useIsHighlightOptionPanelEnabledQuery$variables = Record<PropertyKey, never>;
export type useIsHighlightOptionPanelEnabledQuery$data = {
  readonly userPreferences: {
    readonly highlightOptionPanelEnabled: boolean;
  } | null;
};
export type useIsHighlightOptionPanelEnabledQuery = {
  response: useIsHighlightOptionPanelEnabledQuery$data;
  variables: useIsHighlightOptionPanelEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "highlightOptionPanelEnabled"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsHighlightOptionPanelEnabledQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsHighlightOptionPanelEnabledQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8a0218b2e1c99a56ce8c33454f5c992d",
    "id": "0cf895ac8ba230224c74d275c984b0c91d2ac44dddcf2fde63e3993339c6b240",
    "metadata": {},
    "name": "useIsHighlightOptionPanelEnabledQuery",
    "operationKind": "query",
    "text": "query useIsHighlightOptionPanelEnabledQuery{userPreferences{highlightOptionPanelEnabled}}"
  }
};
})();

(node as any).hash = "f1838f0592c7a8f202fdc84d54752216";

export default node;
